import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { Grid } from "react-feather";
import { get } from "lodash";

import Constants from "../../constants";
import { SET_SURFACE_PATTERN } from "../../store/actions/configurationActions";
import { getAppConfig, getLanguage, getMenuCache, getSelectedMenu } from "../../store/sagas/selectors";

// TODO: Haven't figured out how to make eslint-plugin-import ignore the query parameter.
/* eslint-disable import/no-unresolved */
import RectangleStackBondHorizontalIcon from "../../icons/RectangleStackBondHorizontal.svg?url";
import RectangleStackBondVerticalIcon from "../../icons/RectangleStackBondVertical.svg?url";
import RectangleHalfBondHorizontalIcon from "../../icons/RectangleHalfBondHorizontal.svg?url";
import RectangleHalfBondVerticalIcon from "../../icons/RectangleHalfBondVertical.svg?url";
import RectangleThirdBondHorizontalIcon from "../../icons/RectangleThirdBondHorizontal.svg?url";
import RectangleThirdBondVerticalIcon from "../../icons/RectangleThirdBondVertical.svg?url";
import RectangleRandomBondHorizontalIcon from "../../icons/RectangleRandomBondHorizontal.svg?url";
import RectangleRandomBondVerticalIcon from "../../icons/RectangleRandomBondVertical.svg?url";
import RectangleOffsetBondHorizontalIcon from "../../icons/RectangleOffsetBondHorizontal.svg?url";
import HexagonStackBondHorizontalIcon from "../../icons/HexagonStackBondHorizontal.svg?url";
import HexagonStackBondVerticalIcon from "../../icons/HexagonStackBondVertical.svg?url";
import TriangleIsoscelesStackBondHorizontalIcon from "../../icons/TriangleIsoscelesStackBondHorizontal.svg?url";
import TriangleIsoscelesStackBondVerticalIcon from "../../icons/TriangleIsoscelesStackBondVertical.svg?url";
import TriangleIsoscelesHalfBondHorizontalIcon from "../../icons/TriangleIsoscelesHalfBondHorizontal.svg?url";
import TriangleIsoscelesHalfBondVerticalIcon from "../../icons/TriangleIsoscelesHalfBondVertical.svg?url";
import RectangleHerringboneBondHorizontalIcon from "../../icons/RectangleHerringboneBondHorizontal.svg?url";
import RectangleHerringboneBondVerticalIcon from "../../icons/RectangleHerringboneBondVertical.svg?url";
import RectangleOffsetBondVerticalIcon from "../../icons/RectangleOffsetBondVertical.svg?url";
import TriangleRightFallingHorizontalIcon from "../../icons/TriangleRightFallingHorizontal.svg?url";
import TriangleRightRisingHorizontalIcon from "../../icons/TriangleRightRisingHorizontal.svg?url";
import TriangleRightMirroredHorizontalIcon from "../../icons/TriangleRightMirroredHorizontal.svg?url";
import TriangleRightZigzagHorizontalIcon from "../../icons/TriangleRightZigzagHorizontal.svg?url";
import TriangleRightZigzagVerticalIcon from "../../icons/TriangleRightZigzagVertical.svg?url";
/* eslint-enable import/no-unresolved */

type PatternIconsType = {
    [key: string]: {
        [pattern: string]: any;
    };
};

const PatternIcons: PatternIconsType = {
    RECTANGULAR: {
        StackHz: RectangleStackBondHorizontalIcon,
        StackVt: RectangleStackBondVerticalIcon,
        HalfHz: RectangleHalfBondHorizontalIcon,
        HalfVt: RectangleHalfBondVerticalIcon,
        ThirdHz: RectangleThirdBondHorizontalIcon,
        ThirdVt: RectangleThirdBondVerticalIcon,
        RandomHz: RectangleRandomBondHorizontalIcon,
        RandomVt: RectangleRandomBondVerticalIcon,
        OffsetHz: RectangleOffsetBondHorizontalIcon,
        OffsetVt: RectangleOffsetBondVerticalIcon,
        HerringboneHz: RectangleHerringboneBondHorizontalIcon,
        HerringboneVt: RectangleHerringboneBondVerticalIcon,
    },
    HEXAGONAL_REGULAR: {
        StackHz: HexagonStackBondHorizontalIcon,
        StackVt: HexagonStackBondVerticalIcon,
    },
    TRIANGULAR_ISOSCELES: {
        StackHz: TriangleIsoscelesStackBondHorizontalIcon,
        StackVt: TriangleIsoscelesStackBondVerticalIcon,
        HalfHz: TriangleIsoscelesHalfBondHorizontalIcon,
        HalfVt: TriangleIsoscelesHalfBondVerticalIcon,
    },
    TRIANGULAR_RIGHT_ANGLE: {
        FallingHz: TriangleRightFallingHorizontalIcon,
        RisingHz: TriangleRightRisingHorizontalIcon,
        MirroredHz: TriangleRightMirroredHorizontalIcon,
        ZigzagHz: TriangleRightZigzagHorizontalIcon,
        ZigzagVt: TriangleRightZigzagVerticalIcon,
    },
};

const PatternButton = styled.div`
    padding: 5px 7px 5px 7px;
    margin-top: 2px;
    cursor: pointer;
    user-select: none;
    border-radius: 5px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: ${props => props.theme.textColorSecondary};
    transition: all 0.2s ease-in-out;

    &.open {
        background: ${props => props.theme.sideMenu.pattern.backgroundColor};
        border-radius: 5px 5px 0 0;
        box-shadow: 0 2px 2px 1px rgb(0 0 0 / 10%);
    }

    @media (hover) {
        &:hover {
            background: ${props => props.theme.sideMenu.pattern.backgroundColor};
        }
    }
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
`;

const PatternPopup = styled.div`
    position: absolute;
    display: grid;
    grid-template-columns: repeat(auto-fill, 60px);
    grid-gap: 10px;
    justify-content: space-between;
    top: 36px;

    ${({ theme }) =>
        theme.bp.tb`
        top: 28px;
        `}

    width: ${Constants.sideMenuWidth - 70}px;
    z-index: 100;
    padding: 13px;
    background: ${props => props.theme.sideMenu.pattern.backgroundColor};
    box-shadow: 0 2px 2px 1px rgb(0 0 0 / 10%);
    border-radius: 4px;
    box-sizing: border-box;
    /* Hiding popup when not visible to preload icons anyway */
    visibility: hidden;
    &.open {
        visibility: visible;
    }
    ${({ theme }) =>
        theme.bp.xxxl`
        width: 100%;
    `}
`;

const Pattern = styled.div`
    width: 60px;
    height: 60px;
    font-size: 10px;
    word-break: break-word;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: ${props => props.theme.sideMenu.pattern.borderRadius};
    background: #fff;
    &:hover {
        box-shadow: 0 0 0px 3px ${props => props.theme.sideMenu.pattern.hoverColor};
    }
    &.selected {
        box-shadow: 0 0 0px 2px ${props => props.theme.sideMenu.pattern.activeColor};
    }
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
`;

export const PatternSelector = ({ hideLabel }: { hideLabel?: boolean }) => {
    const dispatch = useDispatch();
    const menus = useSelector(getMenuCache);
    const selectedMenu = useSelector(getSelectedMenu);
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const popupRef = useRef(null);

    const menu = menus[selectedMenu];

    // Close popup on when clicking outside - all clicks except those where
    // the target is a descendant of the popup.
    useEffect(() => {
        if (!open) return;

        const handleClosePopup = (event: MouseEvent) => {
            const { target } = event;
            if (!target) return;
            if (!(target instanceof Element)) return;
            let el = target as Element | null;

            let isOutside = true;
            while (el) {
                if (el === popupRef.current || el === buttonRef.current) {
                    isOutside = false;
                    break;
                }
                el = el.parentElement;
            }
            if (isOutside) {
                setOpen(false);
            }
        };

        document.addEventListener("click", handleClosePopup);

        return () => {
            document.removeEventListener("click", handleClosePopup);
        };
    }, [open]);

    if (!menu) return null;

    const selectedItem = menu.items.find(item => item.isSelected);

    const renderPatterns = () => {
        const { tileShape } = menu;
        return menu.availablePatterns.map(v => (
            <Pattern
                key={v}
                className={v === menu.activePattern ? "selected" : ""}
                onClick={() => {
                    if (selectedItem) {
                        dispatch({
                            type: SET_SURFACE_PATTERN,
                            itemId: selectedItem.id,
                            pattern: v,
                            menuId: selectedMenu,
                        });
                        setOpen(false);
                    }
                }}
            >
                <img width={60} height={60} src={PatternIcons[tileShape][v]} alt="" />
            </Pattern>
        ));
    };

    return (
        <>
            <PatternButton ref={buttonRef} className={open ? "open" : ""} onClick={() => setOpen(!open)}>
                <Grid size={15} />{" "}
                {!hideLabel ? (
                    <span style={{ paddingLeft: "5px" }}>
                        {get(appConfig, `translations.${language}.patternButton`, "patternButton")}
                    </span>
                ) : null}
            </PatternButton>
            <PatternPopup ref={popupRef} className={open ? "open" : ""}>
                {renderPatterns()}
            </PatternPopup>
        </>
    );
};
